import { IconSvg } from './IconSvg'
import type { IconProps } from './IconSvg'

/** chevron pointing right. Decorative line icon; always pair with a visible text label. */
export function ChevronRightIcon({ size, className }: IconProps) {
  return (
    <IconSvg size={size} className={className}>
      <path d="M9.5 5.5L16 12l-6.5 6.5" />
    </IconSvg>
  )
}
